module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_5.4fef3763.png";